module.exports = {
  siteMetadata: {
    title: "Fabacus",
  },
  plugins: [
    {
      resolve: "gatsby-plugin-sass"
    },
    {
      resolve: "gatsby-plugin-intl",
      options: {
        path: `${__dirname}/src/intl`,
        languages: [
          "en",
        ],
        defaultLanguage: "en",
        redirect: false
      }
    }
  ]
};
